import type { ITemplatePageConfig } from '~/types/template'

import { EmptyBlock } from '~/components/DynamicScreen/utils'

export const embeddedPage1: ITemplatePageConfig = {
  className: 'page-1',
  hideRenderer: true,
  name: '1. Embedded UI',
  placeholders: [
    {
      category: 'Embedded ui',
      component: EmptyBlock,
      placeholderKey: 'embedded_ui_fullscreen_1',
      type: 'embeddedUi',
    },
  ],
}

export const embeddedPage2: ITemplatePageConfig = {
  className: 'page-2',
  hideRenderer: true,
  name: '2. Embedded UI',
  placeholders: [
    {
      category: 'Embedded ui',
      component: EmptyBlock,
      placeholderKey: 'embedded_ui_fullscreen_2',
      type: 'embeddedUi',
    },
  ],
}

export const embeddedPage3: ITemplatePageConfig = {
  className: 'page-3',
  hideRenderer: true,
  name: '3. Embedded UI',
  placeholders: [
    {
      category: 'Embedded ui',
      component: EmptyBlock,
      placeholderKey: 'embedded_ui_fullscreen_3',
      type: 'embeddedUi',
    },
  ],
}
